import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
type Toast = {
    icon: React.ReactNode;
    msg: string | React.ReactNode;
    bottom?: number;
    backgroundColor?: string;
    textColor?: string;
    duration?: number;
} | null;

interface ToastStore {
    toast: Toast;
    isShown: boolean | null;
    toastTimeout: NodeJS.Timeout | null;
    anim: Animation | null | undefined;
    show: (val: Toast) => void;
    hide: () => void;
    setToastDissapearAnim: (val: Animation | null | undefined) => void;
}

export const useToast = create<ToastStore>()(
    devtools(
        immer((set, get) => ({
            toast: null,
            isShown: null,
            toastTimeout: null,
            anim: null,
            show: (val: Toast) => {
                const timeout = get().toastTimeout;
                const anim = get().anim;

                if (anim) anim?.cancel();
                if (timeout) clearTimeout(timeout);

                set({
                    toast: null,
                    anim: null
                });

                const hide = get().hide;
                const duration = val?.duration || 3000;

                set({
                    toast: val,
                    isShown: true,
                    toastTimeout: setTimeout(() => hide(), duration)
                });
            },
            hide: () => {
                const dispose = () => {
                    const timeout = get().toastTimeout;
                    if (timeout) clearTimeout(timeout);
                    set({
                        toast: null,
                        anim: null,
                        toastTimeout: null,
                    });
                };

                const timeout = get().toastTimeout;
                if (timeout) clearTimeout(timeout);

                set({
                    isShown: false,
                    toastTimeout: setTimeout(() => dispose(), 1000)
                });
            },
            setToastDissapearAnim: (val: Animation | null | undefined) =>
                set({
                    anim: val
                }),
        })),
    ),
);
